// src/components/Signup.tsx

import CommonUtil from '../util/CommonUtil';
import React, { useState, useEffect, FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // 가정: 인증 컨텍스트

const Signup: React.FC = () => {
    const { performSignup } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // 1. 폼 입력을 위한 상태(State)들을 선언합니다.
    const [token, setToken] = useState('');
    const [nickname, setNickname] = useState('');
    const [email, setEmail] = useState('');
    const [inviteLeague, setInviteLeague] = useState<string | null>(null);
    
    // 에러 메시지와 로딩 상태를 관리합니다.
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    // 2. 페이지가 로드될 때 URL 쿼리 파라미터에서 데이터를 추출하여 상태를 초기화합니다.
    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        setToken(queryParams.get('token') || '');
        setNickname(queryParams.get('nickname') || '');
        setEmail(queryParams.get('email') || '');
        setInviteLeague(queryParams.get('invite_league') || '');
    }, [location.search]);

    // 3. 폼 제출 시 실행될 핸들러 함수입니다.
    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        
        event.preventDefault(); // 기본 폼 제출 동작(페이지 새로고침)을 막습니다.
        setError(null); // 이전 에러 메시지를 초기화합니다.
        setIsLoading(true); // 로딩 상태를 활성화합니다.

        try {
            // 4. AuthContext의 performSignup 함수를 호출하여 회원가입을 요청합니다.
            await performSignup({ token, nickname, email, inviteLeague });

            CommonUtil.logEvent("sign_up");
            // 5. 성공 시, 대시보드 또는 초대받은 리그 페이지로 이동합니다.
            const redirectPath = inviteLeague ? `/league/invite/${inviteLeague}` : '/dashboard';
            navigate(redirectPath, { replace: true });

        } catch (err: any) {
            // 6. 실패 시, 에러 상태를 업데이트하여 사용자에게 메시지를 보여줍니다.
            setError(err.message || '사용 불가능하거나 중복된 닉네임입니다.');
        } finally {
            setIsLoading(false); // 로딩 상태를 비활성화합니다.
        }
            
    };

    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow">
                        <div className="card-header">
                            <h3 className="text-center">회원가입</h3>
                        </div>
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                {/* 토큰은 사용자에게 보이지 않는 hidden input으로 관리합니다. */}
                                <input type="hidden" value={token} readOnly />
                                
                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">이메일</label>
                                    <input 
                                        type="email" 
                                        className="form-control" 
                                        id="email" 
                                        value={email}
                                        readOnly
                                    />
                                </div>
                                
                                <div className="mb-3">
                                    <label htmlFor="nickname" className="form-label">닉네임</label>
                                    <input 
                                        type="text" 
                                        className="form-control" 
                                        id="nickname" 
                                        value={nickname}
                                        onChange={(e) => setNickname(e.target.value)}
                                        placeholder="사용할 닉네임을 입력하세요" 
                                        required
                                        disabled={isLoading}
                                    />
                                    <p className="form-text text-muted">
                                        부적절한 닉네임은 강제로 변경될 수 있습니다.
                                    </p>
                                </div>
                                
                                {/* 에러 메시지를 조건부로 렌더링합니다. */}
                                {error && <div className="alert alert-danger">{error}</div>}
                                
                                <div className="d-grid">
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? '가입 처리 중...' : '회원가입 완료'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signup;
